import React, { Suspense, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { createGlobalStyle } from 'styled-components/macro'
import LoadingComponent from './LoadingComponent'
import MainErrorBoundary from './MainErrorBoundary'

const transitionDuration = 300

export const AnimationStyle = createGlobalStyle`
  .fade-enter {
    opacity: 0;
    transform: translateY(25px);
  }

  .fade-enter.fade-enter-active {
    transition: transform linear ${transitionDuration}ms, opacity ease-in ${transitionDuration}ms;
    transform: translateY(0);
    opacity: 1;
  }
`

export const AsyncComponent = ({ scene, ...props }) => {
  const Comp = React.lazy(async () => {
    const { default: Comp } = await scene
    const AnimatedComp = props => {
      const [entered, setEntered] = useState(false)
      return (
        <CSSTransition in classNames='fade' onEntered={() => setEntered(true)} timeout={transitionDuration}>
          <Comp {...props} entered={entered} />
        </CSSTransition>
      )
    }
    return { default: AnimatedComp }
  })
  return (
    <Suspense fallback={<LoadingComponent />}>
      <MainErrorBoundary>
        <Comp {...props} />
      </MainErrorBoundary>
    </Suspense>
  )
}